/* Luminous Rejuvenation — theme.js
   Consolidated behavior ported from the frozen HTML spec:
   sticky header, mobile menu, hero slider (3 slides / ~5.5s autoplay /
   arrows / dots / swipe / keyboard), FAQ accordion, catalog filter+sort,
   product gallery/variant/quantity, and real Shopify AJAX cart.
*/
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    if (window.AOS) {
      AOS.init({ once: true, duration: 700, easing: 'ease-out', offset: 60 });
    }
    document.documentElement.classList.add('js-aos-ready');
  });

  /* ── STICKY HEADER ── */
  var header = document.getElementById('site-header');
  function onScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 40);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ── MOBILE MENU ── */
  var hamburger = document.getElementById('hamburgerBtn');
  var mobileMenu = document.getElementById('mobile-menu');
  var mobileClose = document.getElementById('mobileClose');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    mobileClose && mobileClose.focus();
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    hamburger && hamburger.focus();
  }
  window.closeMobileMenu = closeMobileMenu;
  hamburger && hamburger.addEventListener('click', openMobileMenu);
  mobileClose && mobileClose.addEventListener('click', closeMobileMenu);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileMenu && mobileMenu.classList.contains('is-open')) closeMobileMenu();
  });
  mobileMenu && mobileMenu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMobileMenu);
  });

  /* ── HERO SLIDER (3 slides, arrows, dots, ~5.5s autoplay, progress bar, swipe, keyboard) ── */
  (function heroSlider() {
    var track = document.getElementById('sliderTrack');
    if (!track) return;
    var slides = document.querySelectorAll('.hero-slide');
    var dots = document.querySelectorAll('.hero-slider__dot');
    var btnPrev = document.getElementById('sliderPrev');
    var btnNext = document.getElementById('sliderNext');
    var countEl = document.getElementById('sliderCountCurrent');
    var progressBar = document.getElementById('sliderProgress');
    var TOTAL = slides.length;
    var current = 0;
    var autoTimer = null;
    var AUTO_DELAY = 5500;
    var isAnimating = false;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function goTo(index, userTriggered) {
      if (isAnimating || index === current) return;
      isAnimating = true;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      dots[current] && dots[current].classList.remove('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'false');

      current = (index + TOTAL) % TOTAL;

      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      dots[current] && dots[current].classList.add('is-active');
      dots[current] && dots[current].setAttribute('aria-selected', 'true');

      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (countEl) countEl.textContent = pad(current + 1);
      if (userTriggered) resetAutoPlay();
      setTimeout(function () { isAnimating = false; }, 900);
    }
    function nextSlide(u) { goTo(current + 1, u); }
    function prevSlide(u) { goTo(current - 1, u); }

    function startAutoPlay() {
      clearTimeout(autoTimer);
      if (progressBar) {
        progressBar.style.transition = 'none';
        progressBar.style.width = '0%';
        progressBar.getBoundingClientRect();
        progressBar.style.transition = 'width ' + AUTO_DELAY + 'ms linear';
        progressBar.style.width = '100%';
      }
      autoTimer = setTimeout(function () { nextSlide(false); startAutoPlay(); }, AUTO_DELAY);
    }
    function resetAutoPlay() {
      clearTimeout(autoTimer);
      if (progressBar) { progressBar.style.transition = 'none'; progressBar.style.width = '0%'; }
      startAutoPlay();
    }

    var sliderEl = document.getElementById('hero');
    if (sliderEl) {
      sliderEl.addEventListener('mouseenter', function () { clearTimeout(autoTimer); if (progressBar) progressBar.style.transition = 'none'; });
      sliderEl.addEventListener('mouseleave', function () { startAutoPlay(); });
      sliderEl.addEventListener('focusin', function () { clearTimeout(autoTimer); if (progressBar) progressBar.style.transition = 'none'; });
      sliderEl.addEventListener('focusout', function (e) { if (!sliderEl.contains(e.relatedTarget)) startAutoPlay(); });
      sliderEl.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') prevSlide(true);
        if (e.key === 'ArrowRight') nextSlide(true);
      });
      var touchStartX = null, touchStartY = null;
      sliderEl.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX; touchStartY = e.touches[0].clientY;
      }, { passive: true });
      sliderEl.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 44) { dx < 0 ? nextSlide(true) : prevSlide(true); }
        touchStartX = null; touchStartY = null;
      }, { passive: true });
    }
    btnPrev && btnPrev.addEventListener('click', function () { prevSlide(true); });
    btnNext && btnNext.addEventListener('click', function () { nextSlide(true); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i, true); }); });

    slides[0] && slides[0].classList.add('is-active');
    slides[0] && slides[0].removeAttribute('aria-hidden');
    startAutoPlay();
  }());

  /* ── FAQ ACCORDION ── */
  var faqTriggers = document.querySelectorAll('.faq-item__trigger');
  faqTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';
      var answer = document.getElementById(trigger.getAttribute('aria-controls'));
      faqTriggers.forEach(function (t) {
        if (t !== trigger) {
          t.setAttribute('aria-expanded', 'false');
          var a = document.getElementById(t.getAttribute('aria-controls'));
          if (a) a.classList.remove('is-open');
        }
      });
      trigger.setAttribute('aria-expanded', String(!isExpanded));
      if (answer) answer.classList.toggle('is-open', !isExpanded);
    });
  });

  /* ── CATALOG / COLLECTION FILTER + SORT ── */
  (function catalogFilters() {
    var filterTabs = document.querySelectorAll('.filter-tab');
    var cards = Array.from(document.querySelectorAll('.catalog-card'));
    var countEl = document.getElementById('productCount');
    var emptyEl = document.getElementById('catalogEmpty');
    if (!filterTabs.length || !cards.length) return;

    function applyFilter(category) {
      var visible = 0;
      cards.forEach(function (card) {
        var match = category === 'all' || card.dataset.category === category;
        card.hidden = !match;
        if (match) visible++;
      });
      if (countEl) countEl.textContent = visible;
      if (emptyEl) emptyEl.classList.toggle('is-visible', visible === 0);
    }
    filterTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        filterTabs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        applyFilter(tab.dataset.filter);
      });
    });
    var sortSelect = document.getElementById('catalogSort');
    var grid = document.getElementById('catalogGrid');
    sortSelect && sortSelect.addEventListener('change', function () {
      var method = this.value;
      var sorted = Array.from(grid.querySelectorAll('.catalog-card')).sort(function (a, b) {
        if (method === 'price-asc') return parseFloat(a.dataset.price) - parseFloat(b.dataset.price);
        if (method === 'price-desc') return parseFloat(b.dataset.price) - parseFloat(a.dataset.price);
        if (method === 'rating') return parseFloat(b.dataset.stars) - parseFloat(a.dataset.stars);
        return parseFloat(a.dataset.order) - parseFloat(b.dataset.order);
      });
      sorted.forEach(function (card) { grid.appendChild(card); });
    });
  }());

  /* ── PRODUCT GALLERY ── */
  var mainImg = document.getElementById('gallery-main-img');
  var thumbBtns = document.querySelectorAll('.product-gallery__thumb');
  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var newSrc = btn.getAttribute('data-full');
      if (newSrc && mainImg) {
        mainImg.src = newSrc;
        thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      }
    });
  });

  /* ── VARIANT SELECTOR (maps buttons to a real <select> of product variants) ── */
  var variantBtns = document.querySelectorAll('.product-variant-btn');
  var variantLabel = document.getElementById('variant-selected-label');
  var variantSelect = document.getElementById('product-variant-select');
  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      variantBtns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      if (variantLabel) variantLabel.textContent = btn.getAttribute('data-variant');
      if (variantSelect) {
        variantSelect.value = btn.getAttribute('data-variant-id');
        variantSelect.dispatchEvent(new Event('change'));
      }
    });
  });

  /* ── QUANTITY SELECTOR ── */
  var qtyInput = document.getElementById('qty-input');
  var qtyDec = document.getElementById('qty-dec');
  var qtyInc = document.getElementById('qty-inc');
  if (qtyDec && qtyInc && qtyInput) {
    qtyDec.addEventListener('click', function () { var v = parseInt(qtyInput.value, 10); if (v > 1) qtyInput.value = v - 1; });
    qtyInc.addEventListener('click', function () { var v = parseInt(qtyInput.value, 10); if (v < 10) qtyInput.value = v + 1; });
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) qtyInput.value = 1;
      if (v > 10) qtyInput.value = 10;
    });
  }

  /* ── ADD TO CART (real Shopify AJAX Cart API) ── */
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var cartBtn = document.getElementById('add-to-cart-btn');
      var formData = new FormData(productForm);
      if (cartBtn) cartBtn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () {
          if (cartBtn) {
            var original = cartBtn.innerHTML;
            cartBtn.innerHTML = '&#10003; Added to Cart';
            setTimeout(function () { cartBtn.innerHTML = original; cartBtn.disabled = false; }, 2200);
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(function () { if (cartBtn) cartBtn.disabled = false; });
    });
  }

  /* Quick-add buttons on catalog / shop / home cards (real AJAX cart, product id via data attr) */
  document.querySelectorAll('[data-quick-add-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-quick-add-id');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function () { document.dispatchEvent(new CustomEvent('cart:updated')); });
    });
  });

  /* ── SMOOTH SCROLL for on-page anchors ── */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = anchor.getAttribute('href');
      if (targetId === '#' || targetId.length < 2) return;
      var target;
      try { target = document.querySelector(targetId); } catch (err) { return; }
      if (target) {
        e.preventDefault();
        var hh = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - hh - 16, behavior: 'smooth' });
      }
    });
  });

  /* ── FOOTER YEAR ── */
  var yearEl = document.getElementById('footer-year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();


  /* ── SEARCH TOGGLE ── */
  var searchToggle = document.getElementById('searchToggle');
  var searchPanel = document.getElementById('site-search');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hasAttribute('hidden');
      if (open) { searchPanel.removeAttribute('hidden'); document.getElementById('site-search-input').focus(); }
      else { searchPanel.setAttribute('hidden', ''); }
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !searchPanel.hasAttribute('hidden')) {
        searchPanel.setAttribute('hidden', '');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  /* ── CART BADGE (live count) ── */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
        });
      });
  }
  document.addEventListener('cart:updated', refreshCartCount);

  

  document.addEventListener('DOMContentLoaded', function () {

  const hamburgerBtn = document.getElementById('hamburgerBtn');
  const mobileMenu = document.querySelector('.site-header__mobile-menu');

  if (!hamburgerBtn || !mobileMenu) return;

  hamburgerBtn.addEventListener('click', function () {

    const isOpen = mobileMenu.style.display === 'flex';

    if (isOpen) {
      // CLOSE
      mobileMenu.style.display = 'none';
      mobileMenu.style.opacity = '0';
    } else {
      // OPEN
      mobileMenu.style.display = 'flex';
      mobileMenu.style.opacity = '1';
    }

  });

});

 // search panel

 document.addEventListener('DOMContentLoaded', function () {
  const toggleBtn = document.getElementById('searchToggle');
  const closeBtn = document.getElementById('searchClose');
  const panel = document.getElementById('site-search');
  const input = document.getElementById('siteSearchInput');
  const resultsEl = document.getElementById('siteSearchResults');
  let debounceTimer;

  if (!toggleBtn || !panel) {
    console.warn('Search toggle button or panel not found in DOM');
    return;
  }

  function openSearch() {
    panel.classList.add('is-open');
    toggleBtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearch() {
    panel.classList.remove('is-open');
    toggleBtn.setAttribute('aria-expanded', 'false');
    resultsEl.innerHTML = '';
    input.value = '';
  }

  toggleBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (panel.classList.contains('is-open')) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  closeBtn.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) closeSearch();
  });

  document.addEventListener('click', function (e) {
    if (panel.classList.contains('is-open') && !panel.contains(e.target) && e.target !== toggleBtn) {
      closeSearch();
    }
  });

  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    const query = input.value.trim();
    if (query.length < 2) {
      resultsEl.innerHTML = '';
      return;
    }
    debounceTimer = setTimeout(function () { fetchResults(query); }, 250);
  });

  function fetchResults(query) {
    resultsEl.innerHTML = '<div class="site-search__loading">Searching...</div>';
    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        const products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          resultsEl.innerHTML = '<div class="site-search__no-results">No products found.</div>';
          return;
        }
        let html = '';
        products.forEach(function (p) {
          const imgUrl = (p.featured_image && p.featured_image.url) || p.image || '';
          html += '<a href="' + p.url + '" class="site-search__result-item">' +
                    '<img src="' + imgUrl + '" alt="' + p.title + '">' +
                    '<div>' +
                      '<div class="site-search__result-title">' + p.title + '</div>' +
                      '<div class="site-search__result-price">' + p.price + '</div>' +
                    '</div>' +
                  '</a>';
        });
        resultsEl.innerHTML = html;
      })
      .catch(function () {
        resultsEl.innerHTML = '<div class="site-search__no-results">Something went wrong. Try again.</div>';
      });
  }
});



}());
